module.exports = __webpack_public_path__ + "static/media/ic_navigation_single_arrow_right.4674affd.svg";